var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrownSimple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4766 8.51344C22.4766 8.52376 22.4766 8.53313 22.47 8.54344L20.3437 18.2813C20.2783 18.6242 20.0953 18.9335 19.8263 19.1559C19.5573 19.3784 19.2191 19.5001 18.87 19.5H5.12905C4.78013 19.4999 4.44217 19.3781 4.17335 19.1556C3.90452 18.9332 3.72166 18.624 3.65624 18.2813L1.52999 8.54344C1.52999 8.53313 1.5253 8.52376 1.52343 8.51344C1.46523 8.19104 1.51419 7.85845 1.66283 7.56649C1.81146 7.27453 2.05159 7.03926 2.34653 6.89662C2.64146 6.75399 2.97499 6.71184 3.29613 6.77661C3.61728 6.84138 3.9084 7.00952 4.12499 7.25532L7.28155 10.6575L10.6378 3.13032C10.638 3.1272 10.638 3.12407 10.6378 3.12094C10.7578 2.86064 10.9499 2.64018 11.1913 2.48565C11.4327 2.33112 11.7134 2.24899 12 2.24899C12.2866 2.24899 12.5673 2.33112 12.8087 2.48565C13.0501 2.64018 13.2422 2.86064 13.3622 3.12094C13.362 3.12407 13.362 3.1272 13.3622 3.13032L16.7184 10.6575L19.875 7.25532C20.092 7.01134 20.3828 6.84485 20.703 6.78114C21.0233 6.71743 21.3556 6.75997 21.6495 6.9023C21.9434 7.04463 22.1828 7.27899 22.3314 7.56977C22.48 7.86055 22.5297 8.19188 22.4728 8.51344H22.4766Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrownSimple);
export default __webpack_public_path__ + "static/media/crown-simple.eb5e16f6707c8fba110da3c7c3bae7a9.svg";
export { ForwardRef as ReactComponent };